<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>老师签到日志</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="老师ID" >
                <Input name="tchId"
                  v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item  label="老师姓名">
                <Input placeholder="支持模糊搜索" name="tchName"
                  v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师账号">
                <Input placeholder="支持模糊搜索" name="tchEmail"
                  v-model="queryParam.tchEmail"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
              @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchSignLog/list"
      :params="queryParam" :onLoading="onLoading" operator=""></List>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :successCallback="search"></tch-info-modal>
  </div>
</template>
<script>
  import TchInfoModal from './modal/TchInfoModal.vue'
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    components: { TchInfoModal },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        rankScoreSeq: 0,
        reload: 0,
        showTchInfoModal: false,
        tchId: null,
        queryParam: {
          tchId: '',
          tchName: '',
          tchEmail: ''
        },
        title: [
          {
            title: '老师姓名',
            // width: 120,
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
                score: row.monthRankScore,
                onClick: () => this.openTchInfoModal(row.tchId)
              })
            }
          },
          {
            title: '老师账号',
            key: 'tchEmail',
            // width: 100,
            align: 'center',
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let startTime = params.row.startTime
              let endTime = params.row.endTime
              return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm:ss') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '状态',
            // width: 80,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.tchSignLogStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '签到时间',
            align: 'center',
            // width: 170,
            render: (h, params) => {
              let updateTime = params.row.updateTime
              return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            renderHeader (h, params) {
              return h('div', [h('span', '是否'), h('br'), h('span', '是补签')])
            },
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let isOperatorSign = params.row.isOperatorSign
              let sign = isOperatorSign === 1 ? '是' : '否'
              return h('span', sign)
            }
          },
          {
            // width: 100,
            align: 'center',
            renderHeader (h, params) {
              return h('div', [h('span', '补签'), h('br'), h('span', '操作人')])
            },
            key: 'operator'
          },
          {
            title: '补签时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let operatorTime = params.row.operatorTime
              return h('span', operatorTime && $moment(operatorTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '创建时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let createTime = params.row.createTime
              return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '操作',
            align: 'center',
            // width: 80,
            render: (h, params) => {
              if (params.row.status === 2) {
                return h('div', [
                  h('a', {on: { click: () => { this.onCancel(params.row) } }}, '补签')
                ])
              }
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      openTchInfoModal (val) {
        this.tchId = val
        this.showTchInfoModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      // 补签
      onCancel (row) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '确定补签？',
          width: 300,
          loading: true,
          onOk: () => {
            self.$http.post('/tchSignLog/makeUp', {id: row.id}).then(function (res) {
              self.search()
              self.$Message.success('补签成功!')
              self.$Modal.remove()
            })
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// TchSignLogList.vue?6a12472d